import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/images/logo-color.svg'
import _imports_1 from '@/assets/images/logo-white.svg'


const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "pl-6 d-row align-center justify-start v-col-sm-5 v-col-md-3 v-col-lg-3 v-col-xl-2 v-col-12" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex d-row align-center justify-start"
}
const _hoisted_4 = {
  key: 1,
  class: "d-flex align-center justify-center",
  style: {"flex":"1"}
}
const _hoisted_5 = {
  key: 2,
  class: "d-flex align-center justify-center",
  style: {"flex":"1"}
}
const _hoisted_6 = {
  class: "d-flex align-center justify-end",
  style: {"flex":"1"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mr-4" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "mr-4" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "mr-4" }, null, -1)

import { useUserStore } from '@/store/user';
import LanguageMenu from '@/components/structure/LanguageMenu';
import UserProfileMenu from '@/components/structure/UserProfileMenu';
import CompanyProfileMenu from '@/components/structure/CompanyProfileMenu';
import AddCompanyDialog from '@/components/company/AddCompanyDialog';
import ChangeCompanyDialog from '@/components/company/ChangeCompanyDialog';
import { useI18n } from 'vue-i18n';
import { withDefaults } from 'vue';
import { useChangeCurrentAppVisualizzation } from '@/composables/user';
import { useAddCompany, useAddMeToCompany } from '@/composables/companies';
import { useDialogsStore } from '@/store/dialogs';
import { useRouter, useRoute } from 'vue-router';
import { RoutesNames } from '@/router/routesNames';
import { checkViewType } from '@/composables/auth';
import { signoutUser, goToDashboard } from '@/composables/auth';
import { isSmallDevice } from '@/utils/helpers';
import { EnvVars, getEnv } from '@/utils/env';

interface AppNavbarProps {
    theme?: string;
    type?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppNavbar',
  props: {
    theme: { default: 'white' },
    type: { default: 'internal' }
  },
  setup(__props: any) {

const router = useRouter();
const route = useRoute();
const dialogsStore = useDialogsStore();
const { t } = useI18n();

const dashboards = [
    {
        label: 'Hiring & Staffing',
        route: '',
        class: '',
    },
    {
        label: 'Management',
        route: '',
        class: 'ml-4',
    },
    {
        label: 'Training',
        route: RoutesNames.company_dashboard,
        class: 'ml-4',
    },
];

const props = __props;

const userStore = useUserStore();

const {
    mutate: changeCurrentAppVisualizzation,
    loading: loadingUpdate,
    onDone: onDonechangeCurrentAppVisualizzation,
} = useChangeCurrentAppVisualizzation();

const {
    mutate: addCompany,
    loading: loadingAdd,
    onDone: onDoneAdd,
    result: resultAddCompany,
} = useAddCompany();

const {
    mutate: addMeToCompany,
    loading: loadingAddMe,
    onDone: onDoneAddMe,
} = useAddMeToCompany();

function companyApproved() {
    return !!userStore.currentCompany?.company_approval_date;
}

function userApproved() {
    return (
        !!userStore.currentCompany?.user_approval_date &&
        userStore.currentCompany.user_approval_date !== ''
    );
}

function showActionMenu() {
    if (!userStore.user) {
        return false;
    }
    if (
        !userStore.privacyAccepted ||
        !userStore.emailVerified ||
        !userStore.secondTermsAccepted
    ) {
        return false;
    }
    return true;
}

function showCompanyMenu() {
    const show = !userStore.viewTypeUser && !!companyApproved() && !!userApproved();
    return show;
}

function showOtherElementsMenu() {
    return showCompanyMenu() || !!userStore.viewTypeUser;
}

function hasCompany() {
    return userStore.allCompanies?.length > 0;
}
function hasMoreCompany() {
    return userStore.allCompanies?.length > 1;
}

async function companyAdded(company) {
    await addCompany({
        input: company,
    });
}

async function companyAddSelected({ company, role }) {
    await addMeToCompany({ role: role.toUpperCase(), companyId: company.id });
}

async function companySelected(companyId) {
    await changeCurrentAppVisualizzation({
        companyId,
    });
}
onDonechangeCurrentAppVisualizzation(() => {
    goToDashboard();
});

function goTo(routeName: RoutesNames) {
    router.push({ name: routeName });
}

function colorButton(routeName: RoutesNames) {
    if (routeName === RoutesNames.company_dashboard_courses_create) {
        const routesJob = [RoutesNames.company_dashboard_courses_create];
        if (routesJob.includes(route.name as string)) {
            return 'primary';
        }
    } else {
        if ((route.name as string) === routeName) {
            return 'primary';
        }
    }
    return props.theme === 'white' ? 'subtitle' : 'white';
}

function getStyle() {
    if (props.theme === 'white') {
        return 'z-index: 1; background-color: #fff';
    }
    return '';
}

function getDashboardButtonTextStyle(routeName: RoutesNames) {
    var style = 'font text-body-2 ';
    if (route.name == routeName) {
        return style + 'font-weight-bold text-primary';
    } else return style + 'text-secondary';
}

function getDashboardButtonColor(routeName: RoutesNames) {
    if (route.name == routeName) {
        return 'primary';
    } else return 'lightGray';
}

function openDashboard(name: string) {
    if (name == 'Hiring & Staffing') {
        window.location.href = getEnv(EnvVars.VUE_APP_DOMAIN) + '/company/hiring';
    } else if (name == 'Management') {
        window.location.href = getEnv(EnvVars.VUE_APP_DOMAIN) + '/company/management';
    }
}

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(getStyle())
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (props.theme === 'white')
          ? (_openBlock(), _createBlock(_component_v_img, {
              key: 0,
              height: "50",
              width: "50",
              class: "cursor",
              onClick: _unref(checkViewType),
              src: _imports_0
            }, null, 8, ["onClick"]))
          : (_openBlock(), _createBlock(_component_v_img, {
              key: 1,
              height: "50",
              width: "50",
              class: "cursor",
              onClick: _unref(checkViewType),
              src: _imports_1
            }, null, 8, ["onClick"]))
      ]),
      (_unref(route).name == _unref(RoutesNames).company_dashboard)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(dashboards, (dashboard) => {
              return _createVNode(_component_v_btn, {
                key: dashboard.label,
                elevation: "0",
                variant: "outlined",
                color: getDashboardButtonColor(dashboard.route as RoutesNames),
                rounded: "pill",
                class: _normalizeClass(dashboard.class),
                onClick: ($event: any) => (openDashboard(dashboard.label))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass(
                            getDashboardButtonTextStyle(dashboard.route as RoutesNames)
                        )
                  }, _toDisplayString(dashboard.label), 3)
                ]),
                _: 2
              }, 1032, ["color", "class", "onClick"])
            }), 64))
          ]))
        : _createCommentVNode("", true),
      (
                    !_unref(userStore).viewTypeUser &&
                    !_unref(isSmallDevice)() &&
                    _unref(route).name != _unref(RoutesNames).company_dashboard
                )
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_v_btn, _mergeProps({
              color: colorButton(_unref(RoutesNames).company_dashboard_courses_create),
              density: "comfortable"
            }, props, {
              elevation: "0",
              variant: "text",
              class: "font mr-6 text-none",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (goTo(_unref(RoutesNames).company_dashboard_courses_create)))
            }), {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('create_course')), 1)
              ]),
              _: 1
            }, 16, ["color"]),
            _createVNode(_component_v_btn, {
              color: colorButton(_unref(RoutesNames).company_dashboard_courses_list),
              density: "comfortable",
              elevation: "0",
              variant: "text",
              class: "font mr-6 text-none",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (goTo(_unref(RoutesNames).company_dashboard_courses_list)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('course_list')), 1)
              ]),
              _: 1
            }, 8, ["color"]),
            _createVNode(_component_v_btn, {
              color: colorButton(_unref(RoutesNames).company_dashboard_courses_trainers),
              density: "comfortable",
              elevation: "0",
              variant: "text",
              class: "font mr-6 text-none",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (goTo(_unref(RoutesNames).company_dashboard_courses_trainers)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('course_trainer')), 1)
              ]),
              _: 1
            }, 8, ["color"])
          ]))
        : _createCommentVNode("", true),
      (_unref(userStore).viewTypeUser && !_unref(isSmallDevice)())
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_v_btn, _mergeProps({
              color: colorButton(_unref(RoutesNames).dashboard),
              density: "comfortable"
            }, props, {
              elevation: "0",
              variant: "text",
              class: "font mr-6 text-none",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (goTo(_unref(RoutesNames).dashboard)))
            }), {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('course_list')), 1)
              ]),
              _: 1
            }, 16, ["color"]),
            _createVNode(_component_v_btn, {
              color: colorButton(_unref(RoutesNames).dashboard_enrollment),
              density: "comfortable",
              elevation: "0",
              variant: "text",
              class: "font mr-6 text-none",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (goTo(_unref(RoutesNames).dashboard_enrollment)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('course_subscription')), 1)
              ]),
              _: 1
            }, 8, ["color"]),
            _createVNode(_component_v_btn, {
              color: colorButton(_unref(RoutesNames).dashboard_nextLessons),
              density: "comfortable",
              elevation: "0",
              variant: "text",
              class: "font mr-6 text-none",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (goTo(_unref(RoutesNames).dashboard_nextLessons)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('course_next_lessons')), 1)
              ]),
              _: 1
            }, 8, ["color"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        (
                        showActionMenu() &&
                        !showOtherElementsMenu() &&
                        hasMoreCompany() &&
                        props.type !== 'public'
                    )
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              color: props.theme === 'white' ? 'subtitle' : 'white',
              density: "comfortable",
              elevation: "0",
              variant: "text",
              class: "font mr-4 text-none",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(dialogsStore).changeCompany = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('change_company')), 1)
              ]),
              _: 1
            }, 8, ["color"]))
          : _createCommentVNode("", true),
        (showOtherElementsMenu() || props.type === 'public')
          ? (_openBlock(), _createBlock(_unref(LanguageMenu), {
              key: 1,
              showTitle: !_unref(isSmallDevice)(),
              theme: props.theme
            }, null, 8, ["showTitle", "theme"]))
          : _createCommentVNode("", true),
        _hoisted_7,
        (
                        showActionMenu() && showCompanyMenu() && props.type !== 'public'
                    )
          ? (_openBlock(), _createBlock(_unref(CompanyProfileMenu), {
              key: 2,
              company: _unref(userStore).currentCompany,
              theme: props.theme
            }, null, 8, ["company", "theme"]))
          : _createCommentVNode("", true),
        _hoisted_8,
        (showActionMenu() && !!_unref(userStore).user && props.type !== 'public')
          ? (_openBlock(), _createBlock(_unref(UserProfileMenu), {
              key: 3,
              user: _unref(userStore).user,
              isTalent: 
                        _unref(userStore).viewTypeUser === null ? false : _unref(userStore).viewTypeUser
                    ,
              theme: props.theme,
              company: _unref(userStore).currentCompany
            }, null, 8, ["user", "isTalent", "theme", "company"]))
          : _createCommentVNode("", true),
        (!showActionMenu() && _unref(userStore).user && props.type !== 'public')
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 4,
              class: "font ml-6",
              flat: "",
              variant: "text",
              rounded: "pill",
              color: "title",
              onClick: _unref(signoutUser)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('exit')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_9
    ]),
    _createVNode(_unref(AddCompanyDialog), {
      onCompanyAdded: companyAdded,
      onCompanyAddSelected: companyAddSelected
    }),
    _createVNode(_unref(ChangeCompanyDialog), { onCompanySelected: companySelected }),
    (!showOtherElementsMenu() && props.type !== 'public')
      ? (_openBlock(), _createBlock(_component_v_divider, {
          key: 0,
          color: "primary",
          thickness: "4"
        }))
      : (_openBlock(), _createBlock(_component_v_divider, { key: 1 }))
  ], 4))
}
}

})